"use strict";
var core_1 = require('@angular/core');
var RioContainer = (function () {
    function RioContainer() {
        this.size = 1;
        this.center = false;
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], RioContainer.prototype, "size", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], RioContainer.prototype, "center", void 0);
    RioContainer = __decorate([
        core_1.Component({
            selector: 'rio-container',
            template: "\n  <div\n    class=\"clearFix px1\"\n    [ngClass]= \"{\n      'max-width-1': size === 1,\n      'max-width-2': size === 2,\n      'max-width-3': size === 3,\n      'max-width-4': size === 4,\n      'mx-auto': center\n    }\">\n    <ng-content></ng-content>\n  <div>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], RioContainer);
    return RioContainer;
}());
exports.RioContainer = RioContainer;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBQWlDLGVBQWUsQ0FBQyxDQUFBO0FBa0JqRDtJQUFBO1FBQ1csU0FBSSxHQUFHLENBQUMsQ0FBQztRQUNULFdBQU0sR0FBRyxLQUFLLENBQUM7SUFDMUIsQ0FBQztJQUZDO1FBQUMsWUFBSyxFQUFFOzs4Q0FBQTtJQUNSO1FBQUMsWUFBSyxFQUFFOztnREFBQTtJQWxCVjtRQUFDLGdCQUFTLENBQUM7WUFDVCxRQUFRLEVBQUUsZUFBZTtZQUN6QixRQUFRLEVBQUUsaVJBWVQ7U0FDRixDQUFDOztvQkFBQTtJQUlGLG1CQUFDO0FBQUQsQ0FBQyxBQUhELElBR0M7QUFIWSxvQkFBWSxlQUd4QixDQUFBO0FBQUEsQ0FBQyJ9


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/container/index.ts
 ** module id = 958
 ** module chunks = 1
 **/